module.exports = __webpack_public_path__ + "img/overview.577bb4cf.svg";